import { Button, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";

import AppIcon from "@/common/components/Icons/AppIcon";
import { RepairWorkDto } from "@/core/api/generated/v1";

import RepairWorkAutocomplete, { RepairWorkAutocompleteProps } from "./RepairWorkAutocomplete";
import RepairWorkCreateUpdate, { RepairWorkCreateUpdateProps } from "./RepairWorkCreateUpdate";
import RepairWorkCreateUpdateModal from "./RepairWorkCreateUpdateModal";

interface OwnProps {
  autocompleteProps: RepairWorkAutocompleteProps;
  createUpdateRepairWorkProps?: Pick<RepairWorkCreateUpdateProps, "defaultValues">;
  createFormPlacement?: "modal" | "page";
  onCreateStart?: () => void;
  onCreate: (newValue: RepairWorkDto) => void;
}

type Props = OwnProps;

export default function SelectOrCreateRepairWork({
  autocompleteProps,
  createUpdateRepairWorkProps,
  createFormPlacement = "modal",
  onCreateStart,
  onCreate,
}: Props) {
  const [isCreate, setIsCreate] = useState(false);
  const [defaultValues, setDefaultValues] = useState<
    RepairWorkCreateUpdateProps["defaultValues"] | undefined
  >(undefined);

  return (
    <Stack spacing={2}>
      {/* 1. Search repairWork */}
      {!isCreate && (
        <Box>
          <RepairWorkAutocomplete
            {...autocompleteProps}
            withCreate
            onCreate={(newOption) => {
              setDefaultValues({
                ...createUpdateRepairWorkProps?.defaultValues,
                name: newOption?.inputValue || undefined,
              });
              setIsCreate(true);
              onCreateStart && onCreateStart();
            }}
          />
        </Box>
      )}

      {isCreate && (
        <Box>
          {isCreate && (
            <>
              {createFormPlacement === "modal" && (
                <RepairWorkCreateUpdateModal
                  open={isCreate}
                  onClose={() => setIsCreate(false)}
                  createUpdateProps={{
                    defaultValues: defaultValues,
                    onCreate: onCreate,
                    onSave: (newValue) => {
                      setIsCreate(false);
                    },
                  }}
                />
              )}

              {createFormPlacement === "page" && (
                <Stack spacing={1}>
                  <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
                    <Button
                      variant='text'
                      color='text'
                      size='small'
                      startIcon={<AppIcon of='goBack' />}
                      onClick={() => setIsCreate(false)}
                    >
                      Back to search
                    </Button>

                    <Typography component='div' variant='subtitle1'>
                      Create new repair work
                    </Typography>
                  </Stack>

                  <RepairWorkCreateUpdate
                    defaultValues={defaultValues}
                    onCreate={onCreate}
                    onSave={(newValue) => {
                      setIsCreate(false);
                    }}
                  />
                </Stack>
              )}
            </>
          )}
        </Box>
      )}
    </Stack>
  );
}
